import { render, staticRenderFns } from "./reminderSetting.vue?vue&type=template&id=206d193a&scoped=true"
import script from "./reminderSetting.vue?vue&type=script&lang=js"
export * from "./reminderSetting.vue?vue&type=script&lang=js"
import style0 from "./reminderSetting.vue?vue&type=style&index=0&id=206d193a&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "206d193a",
  null
  
)

export default component.exports